import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["sourceId", "isEmbedded"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { getInstalledAppOverviewUrl, navigateTo } from '../utils/DetailsPageUrls';
import { trackCustomMarketplaceOfferingBehavioralEvent } from '../utils/TrackingUtils';
import { SettingsIcon } from 'foundations-assets/icons/components/SettingsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ManageButton(_ref) {
  let {
      sourceId,
      isEmbedded = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    trackInteraction
  } = useDetailsPageContext();
  return /*#__PURE__*/_jsxs(Button, Object.assign({
    "data-test-id": "manage-button",
    onClick: () => {
      trackInteraction({
        action: 'click manage app button'
      });
      trackCustomMarketplaceOfferingBehavioralEvent('MANAGE_APP_CLICK');
      navigateTo(getInstalledAppOverviewUrl(sourceId !== null && sourceId !== void 0 ? sourceId : ''), isEmbedded);
    },
    use: "primary"
  }, rest, {
    children: [/*#__PURE__*/_jsx(SettingsIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.productDetailsCard.cta.manage"
    })]
  }));
}